import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { flex, stickyFormBlock } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    modal: {
        width: 508,
        maxHeight: 'calc(100dvh - 50px)',
        fallbacks: { maxHeight: 'calc(100vh - 50px)' },
        overflowY: 'auto',
        maxWidth: 'calc(100vw - 32px)',
        [theme.down('desktop')]: {
            width: 'calc(100vw - 32px)',
            maxHeight: 'calc(100dvh - 32px)',
            fallbacks: { maxHeight: 'calc(100vh - 32px)' },
        },
    },

    heading: {
        ...flex('row', 'space-between', ''),
    },

    loader: {
        color: theme.colors.violet_primary,
    },

    h2: {
        fontFamily: theme.font.secondary,
        fontSize: 24,
        lineHeight: 1.33,
        color: theme.colors.black,
        fontWeight: 'normal',
        marginBottom: theme.spacing(7),
    },
    imageContainer:{
        display: 'flex',
        width: 32,
        height: 32,
        padding: '0 8px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        borderRadius: 4,

        '& img':{
            // marginRight: theme.spacing(2),
            width: 22,
            height: 22,

            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
                cursor: 'pointer',
            },
        },
    },
    field: {
        marginBottom: theme.spacing(6),
    },
    dropdown: {
        margin: 0,
    },
    errors: {
        ...stickyFormBlock(theme.colors.white),
    },
    error: {
        backgroundColor: theme.colors.red,
        marginBottom: theme.spacing(2),
    },

    buttons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 10,
    },
    cancel: {
        marginRight: theme.spacing(5),
    },
}));
